import { styled } from 'styled-components';
import { Text } from '@comicrelief/component-library';
import StepSlider from '@/components/stepSlider/StepSlider';

const StyledHeading2 = styled(Text)`
  margin-top: 1rem;
  && {
    line-height: normal;
  }
`;

interface PageHeaderProps {
  currentStep: number;
  totalSteps: number;
  headerText: string;
  initialText: string;
  supplementaryText?: string;
}

export default function PageHeaderSimplified({
  currentStep,
  totalSteps,
  headerText,
  initialText,
  supplementaryText = ''
}: PageHeaderProps) {
  return (
    <>
      <Text
        tag="h1"
        family="Anton"
        size="lg"
        color="black"
        uppercase
      >
        {headerText}
      </Text>

      <StyledHeading2
        tag="h2"
        family="Montserrat"
        size="s"
        color="black"
        height="1.3rem"
      >
        {initialText}
        {' '}
        {supplementaryText}

      </StyledHeading2>

      <StepSlider
        currentStep={currentStep}
        totalSteps={totalSteps}
      />

    </>
  );
}
